import { Component, Inject, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MatDatepicker, MatDatepickerInputEvent, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';
import moment from 'moment';

export interface DialogData {
  data
}

export const YEAR_FORMATS = {
  parse: {
    dateInput: 'YYYY年',
  },
  display: {
    dateInput: 'YYYY年',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-staff-detail-dialog',
  templateUrl: './staff-detail-dialog.component.html',
  styleUrls: ['./staff-detail-dialog.component.less'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: YEAR_FORMATS},
  ],
})

export class StaffDetailDialogComponent implements OnInit {

  instructEmployment: any = {};

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // 有休履歴表の「表示年」年月日
  selectedYearHistory = new FormControl(moment());

  // 実績時間表の「表示年」年月日
  selectedYearTime = new FormControl(moment());

  // 有休履歴表の「表示年」年のみ
  paidHistoryYear: number = moment(this.selectedYearHistory.value).year();

  // 実績時間表の「表示年」年のみ
  actualTimeYear: number = moment(this.selectedYearTime.value).year();

  // 清掃員コード
  staffDailyCleaning: string;

  // 有休残数
  paidHolidayLeft: string;

  // 有休履歴
  paidHolidayList: any;

  // 次回の有休付与情報
  nextPaidHoliday = { date: '', given: '', remove: '' };

  // 作業実績
  monthWorkRecord: any;

  // 選択した物件（物件単位）
  selectedSite: any;

  // 物件のドロップダウン（今月に作業終了した・今日以降に適用される雇用指示がある物件）
  siteData = [];

  // 選択した物件の雇用指示（契約コードごと。それぞれに賃金 wages を持つ）
  employments = [];

  // 曜日の列
  weekList = [
    { key: 'mon', name: '月' },
    { key: 'tue', name: '火' },
    { key: 'wed', name: '水' },
    { key: 'thu', name: '木' },
    { key: 'fri', name: '金' },
    { key: 'sat', name: '土' },
    { key: 'sun', name: '日' }
  ];

  // 契約中の物件がない
  noContractSite = false;
  
  // 有休履歴リストのデータ数がない
  noPaidHolidayList = false;

  // ローディング中
  nowLoading = false;

  // 代勤スキル
  skill: any = {};

  // 登録ボタン非活性⇒true
  registerRankDisable = false;
  registerDisable1 = false;

  // 出禁リスト
  banned = [];

  // 取得できなかったものの名前（画面の上に出す）
  failed: string[] = [];
  // 有休履歴・実績時間を取得できなかった
  failedHistory = false;
  failedRecord = false;

  // httpヘッダー
  public httpOptions;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) { }

  ngOnInit() {
    // console.log(this.data)
    let staff = this.data.data.staffDailyCleaning;
    // 稼働管理から開いたときは、その物件を選んだ状態にする
    let cdSite = this.data.data.cdSite || null;

    if (cdSite == '0') {
      cdSite = null
    }
    // 登録のあと開き直したときは、選んでいた物件のままにする
    if (this.selectedSite && this.selectedSite.cdSite) {
      cdSite = this.selectedSite.cdSite
    }

    this.staffDailyCleaning = staff;

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    // 開いたときに要るものは1回でまとめて取得する（有休履歴と実績時間は年を変えるたびに取り直すので別）
    this.open(staff, cdSite);
    this.getPaidHolidays(staff);
    this.getMonthWorkRecord(staff);
  }

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }

  /**
   * 取得・登録に失敗したとき
   * サインインが切れているときだけ最初の画面へ戻す。それ以外はダイアログを使えるままにする
   * @param error エラー
   * @returns 最初の画面へ戻したら true
   */
  isSignOut(error): boolean {
    if (error && (error.status == 401 || error.status == 403)) {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      return true;
    }
    return false;
  }

  /**
   * 開いたときの内容を取得（物件の一覧・清掃員・選んだ物件の雇用指示と賃金・有休残数・代勤スキル・出入り禁止物件）
   * API: staffDetail/open
   * @param staff 清掃員コード
   * @param cdSite 最初に選ぶ物件コード（無ければ先頭の物件）
   */
  open(staff: string, cdSite: string) {
    this.nowLoading = true;
    this.http.get(API_BASE_URL + '/api/v1/staffDetail/open?staffDailyCleaning=' + staff
      + (cdSite ? '&cdSite=' + encodeURIComponent(cdSite) : ''),
      {headers: this.headers}).subscribe((res) => {
        this.failed = res['failed'] || [];

        // 清掃員の内容
        if (res['detail']) {
          this.instructEmployment = res['detail'];
        }

        // 物件ドロップダウン（物件単位）
        this.siteData = res['sites'] || [];
        this.noContractSite = this.siteData.length == 0;
        this.selectedSite = this.siteData.filter(s => s.cdSite == res['cdSite'])[0] || this.siteData[0];

        // 選んだ物件の雇用指示と賃金
        this.employments = res['employments'] || [];

        // 有休残数
        this.paidHolidayLeft = (res['paidHolidayLeft'] || 0) + " 日";

        // 代勤スキル　チェックボックス、　出禁リスト
        this.skill = res['skill'] || {};
        // スキル情報がない場合
        if (!this.skill['staffDailyCleaning']) {
          this.skill = {
            staffDailyCleaning: staff,
            caretaker: false,
            initial: false,
            canInstead: null,
            cleanSkill: null,
            memo: '',
            banned: this.skill['banned']
          }
        }
        // 出禁情報
        this.banned = this.skill['banned'] || [];
        delete this.skill['banned'];

        // 次回の有休付与情報
        this.getNextPaidHoliday(staff)

        this.nowLoading = false;
      },
      error => {
        this.nowLoading = false;
        if (this.isSignOut(error)) return;
        this.failed = ['清掃員の情報'];
    });
  }

  /**
   * 交通費の表示（区分と金額。区分が「無」なら金額は出さない）
   * @param kubun 区分の名前（無・1日・1ヶ月）
   * @param fare 金額
   */
  fareText(kubun: string, fare: number): string {
    if (!kubun || kubun == '無') return '無';
    return kubun + ' ' + Number(fare || 0).toLocaleString() + ' 円';
  }

  /**
   * 曜日の勤務の文字（get_attendance_time_hour_name の「8:00~11:00 (3.00)＋改行＋勤務形態」）を、時間帯・実働・勤務形態に分ける
   * @param val 曜日の勤務の文字。勤務なしは空
   * @returns time：「8:00～11:00」、hours：「3h」、kind：「隔週」など（無ければ空）
   */
  workTime(val: string): { time: string, hours: string, kind: string } {
    const res = { time: '', hours: '', kind: '' };
    if (!val) return res;

    const lines = String(val).split('\n');
    const m = lines[0].match(/^(.*?)\s*\((\d+(?:\.\d+)?)\)\s*$/);
    if (m) {
      res.time = m[1].replace('~', '～');
      // 実働は「3.00」→「3h」「3.50」→「3.5h」
      res.hours = String(Number(m[2])) + 'h';
    } else {
      res.time = lines[0].replace('~', '～');
    }
    res.kind = lines.slice(1).join(' ').trim();
    return res;
  }

  /**
   * 有休履歴を取得
   * @param staffDailyCleaning 清掃員コード
   */
  getPaidHolidays(staffDailyCleaning: string) {
    this.noPaidHolidayList = false;
    this.failedHistory = false;
    this.http.get(API_BASE_URL + '/api/v1/paidHolidays?staffDailyCleaning='
      + staffDailyCleaning
      + '&year=' + this.paidHistoryYear,
      {headers: this.headers})
      .subscribe((res) => {
        this.paidHolidayList = res;
        if (this.paidHolidayList.length == 0) {
          this.noPaidHolidayList = true;
        }
      },
      error => {
        if (this.isSignOut(error)) return;
        this.paidHolidayList = [];
        this.failedHistory = true;
    });
  }

  getNextPaidHoliday(staffDailyCleaning: string) {
    // 入社日有り
    if (this.instructEmployment['dateHire']) {
      const today = moment().startOf('day')

      // 次回付与日：入社日の 6か月後、そのあとは1年ごと。今日より後の最初の日（DB 関数 get_paid_holidays_list と同じ決め方）
      // 入社日から月数を足して求める（年ごとに月日を当てはめると、2/29 のような無い日になる）
      const dateHire = moment(this.instructEmployment['dateHire'].replace('年', '-').replace('月', '-').replace('日', '') + ' 00:00:00')
      let nextDate: moment.Moment
      for (let months = 6; ; months += 12) {
        nextDate = dateHire.clone().add(months, 'months')
        // 同じ日が無く月末に丸められた場合（例: 3/31 → 9/30）は翌日（10/1）にする
        if (nextDate.date() < dateHire.date()) {
          nextDate.add(1, 'days')
        }
        if (nextDate.isAfter(today)) break
      }
      const date = nextDate.format('YYYY-MM-DD')
      this.nextPaidHoliday.date = date

      this.http.get(API_BASE_URL + '/api/v1/paidHolidays/nextData?staffDailyCleaning='
        + staffDailyCleaning
        + "&date=" + date,
        {headers: this.headers})
        .subscribe((res) => {
          if (res) {
            // 付与の計算が取れなかったときは、付与の欄だけ知らせる（消失は出す）
            this.nextPaidHoliday.given = res['givenFailed'] ? '取得できませんでした' : res['note']
            this.nextPaidHoliday.remove = res['disappearNote']
          }
        },
        error => {
          if (this.isSignOut(error)) return;
          this.nextPaidHoliday.given = '取得できませんでした'
          this.nextPaidHoliday.remove = '取得できませんでした'
      });
    } else {
      this.nextPaidHoliday.date = '入社日が取得できていないため、次回付与できません。'
    }
  }

  /**
   * 作業実績(月)を取得
   * @param staffDailyCleaning 清掃員コード
   */
  getMonthWorkRecord(staffDailyCleaning: string) {
    this.failedRecord = false;
    this.http.get(API_BASE_URL + '/api/v1/instructEmployment/monthWorkRecord?staffDailyCleaning='
        + staffDailyCleaning
        + '&year=' + this.actualTimeYear,
      {headers: this.headers})
      .subscribe((ret:any[]) => {
        let newRecord:any[] = [];
        ret.forEach( rec => {
          let future = false;
          if (new Date(rec.workMonth) > new Date()) future = true;

          newRecord.push({
            workMonth: rec.workMonth
          , workDays: future ? '-' : rec.workDays + ' 日'
          , workTimes: future ?  '-' : rec.workTimes
          , paidHolidayUseCount: future ?  '-' : rec.paidHolidayUseCount + ' 日'
          });
        });
        this.monthWorkRecord = newRecord;
      },
      error => {
        if (this.isSignOut(error)) return;
        this.monthWorkRecord = [];
        this.failedRecord = true;
    });
  }

  /**
   * 有休履歴表の「表示年」切替
   * @param normalizedYear 選択した年
   */
  // 手入力した場合
  historyHandlerManual(normalizedYear: MatDatepickerInputEvent<moment.Moment>) {
    const ctrlValue = this.selectedYearHistory.value;
    ctrlValue.year(normalizedYear);
    this.selectedYearHistory.setValue(ctrlValue);
    this.paidHistoryYear = moment(this.selectedYearHistory.value).year();
    this.getPaidHolidays(this.staffDailyCleaning);
  }
  // datepickerで選択した場合
  historyHandler(normalizedYear: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
    const ctrlValue = this.selectedYearHistory.value;
    ctrlValue.year(normalizedYear.year());
    this.selectedYearHistory.setValue(ctrlValue);
    this.paidHistoryYear = moment(this.selectedYearHistory.value).year();
    datepicker.close();
    this.getPaidHolidays(this.staffDailyCleaning);
  }

  /**
   * 実績時間表の「表示年」切替
   * @param normalizedYear 選択した年
   */
  // 手入力した場合
  timeHandlerManual(normalizedYear: MatDatepickerInputEvent<moment.Moment>) {
    const ctrlValue = this.selectedYearTime.value;
    ctrlValue.year(normalizedYear);
    this.selectedYearTime.setValue(ctrlValue);
    this.actualTimeYear = moment(this.selectedYearTime.value).year();
    this.getMonthWorkRecord(this.staffDailyCleaning);
  }

  timeHandler(normalizedYear: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
    const ctrlValue = this.selectedYearTime.value;
    ctrlValue.year(normalizedYear.year());
    this.selectedYearTime.setValue(ctrlValue);
    this.actualTimeYear = moment(this.selectedYearTime.value).year();
    datepicker.close();
    this.getMonthWorkRecord(this.staffDailyCleaning);
  }

  /**
   * 物件選択イベント（選んだ物件の雇用指示と賃金を取り直す）
   * API: staffDetail/site
   */
  onChangeSite() {
    this.nowLoading = true;
    this.http.get(API_BASE_URL + '/api/v1/staffDetail/site?staffDailyCleaning=' + this.staffDailyCleaning
      + '&cdSite=' + encodeURIComponent(this.selectedSite.cdSite),
      {headers: this.headers}).subscribe((res) => {
        this.failed = res['failed'] || [];
        this.employments = res['employments'] || [];
        this.nowLoading = false;
      },
      error => {
        this.nowLoading = false;
        if (this.isSignOut(error)) return;
        this.failed = ['雇用指示'];
    });
  }

  /**
   * スキル登録ボタンイベント（代勤可能・管理業務・初期対応・清掃スキル・備考をまとめて登録）
   * API: skill/save
   */
  register() {
    this.registerDisable1 = true;
    this.skill['createdUser'] = localStorage.getItem("uid");

    this.http.post(
      API_BASE_URL + "/api/v1/skill/save?name=" + this.instructEmployment['nameStaff'], this.skill, this.httpOptions
    ).subscribe(res => {
      alert("登録しました。")
      this.ngOnInit()
      this.registerDisable1 = false;
    },error => {
      this.registerDisable1 = false;
      if (this.isSignOut(error)) return;
      alert("代勤スキルを登録できませんでした。");
    });
  }

  /**
   * ランク登録（物件ランクは契約コードごと）
   * API: contractDetail/note
   * @param emp 雇用指示の行
   */
  registerRank(emp) {
    this.registerRankDisable = true;

    const contractDetailNoteId = {
      cdSite:  emp.cdSite,
      cdContract: emp.cdContract
    }

    const contractDetailNote = {
      contractDetailNoteId,
      rank: emp.rank
    };

    this.http.post(
      API_BASE_URL + '/api/v1/contractDetail/note?siteName=' + this.selectedSite.nameSite
      + '&type=rank'
      + '&title=ランク',
      contractDetailNote, this.httpOptions
    ).subscribe(res => {
      alert("登録しました。")
      this.ngOnInit()
      this.registerRankDisable = false;
    },error => {
      this.registerRankDisable = false;
      if (this.isSignOut(error)) return;
      alert("物件ランクを登録できませんでした。");
    });
  }
}
